<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{pageTitle}}</div>
			<div class="content">
        <a-form-model
          ref="ruleForm"
          :model="selectIndex"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol">
          <a-form-model-item ref="applyItemIndex" label="检测项目" prop="applyItemIndex">
            <a-select
              placeholder="请选择检测项目"
              v-model="selectIndex.applyItemIndex"
              @change="applyItemChange"
              :getPopupContainer="triggerNode => triggerNode.parentNode"
            >
              <a-select-option
                v-for="(item,index) in applyItems"
                :key="index"
                :value="index"
              >{{item.dictValue}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="患者分组">
            <a-select
                style="width:100%;"
                v-model="selectIndex.groupIdIndex"
                placeholder="请选患者分组"
                @change="groupItemChange"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
            >
              <a-select-option
                  v-for="(item,index) in groupDatas"
                  :key="index"
                  :value="index"
              >{{item.groupName}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item ref="patientItemIdIndex" label="流程名称" prop="patientItemIdIndex">
            <a-select
              placeholder="请选择流程名称"
              v-model="selectIndex.patientItemIdIndex"
              @change="patientItemChange"
              :getPopupContainer="triggerNode => triggerNode.parentNode"
            >
              <a-select-option
                v-for="(item,index) in patientDatas"
                :key="index"
                :value="index"
              >{{item.name}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item ref="analyzeIndex" label="分析人员" prop="analyzeIndex">
            <a-tree-select
                v-model="selectIndex.analyzeIndex"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
                style="width: 100%;position:relative"
                :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
                placeholder="请选择"
                :selectable="false"
                allowClear
                autoExpandParent
                showSearch
                :value="selectIndex.analyzeIndex"
                @change="analyzeChange"
                :treeData="treeData"
            >
            </a-tree-select>
          </a-form-model-item>
				</a-form-model>
				<div class="confrim-footer" v-if="!formData.system">
					<a-button @click="submitClick" type="primary" class="cf-mr10">确定</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    props: {
      editJobId: 0,
      editJobRow: {
        type: Object,
        default: () => {
        }
      },
      treeData: {
        type: Array,
        default: () => {
        }
      },
    },
    data() {
      return {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
        data: [],
        rules: {
          applyItemIndex: { required: true, message: '请选择检测项目', trigger: 'blur' },
          patientItemIdIndex: { required: true, message: '请选择流程', trigger: 'blur' },
          analyzeIndex: { required: true, message: '请选择分析人员', trigger: 'blur,change' },
        },
        selectIndex: {
          applyItemIndex: undefined,
          groupIdIndex: undefined,
          patientItemIdIndex: undefined,
          analyzeIndex: undefined
        }, //先选中index,后获取对应的id和name
        formData: {
          applyItem: '',
          applyItemCode: '',
          groupId: '',
          groupName: '',
          pipelineId: '',
          pipelineName: '',
          analyzeId: '',
          analyzeName: ''
        },
        pageTitle: "添加作业设置",
        applyItems: [],
        groupDatas: [],
        patientDatas: [],
        isSubmit: false
      };
    },
    components: {},
    mounted() {
      let bol = false;
      if(this.editJobRow.id) { 
        this.formData = this.editJobRow;
        bol = true;
        this.pageTitle = "编辑作业设置";
        this.selectIndex.analyzeIndex = this.formData.analyzeName;
      }
      this.getApplyItem(bol);//项目
      this.getPipelineLst(bol);//流程
    },
    methods: {
      analyzeChange(value, label, extra) {
        let tag = value ? extra.triggerNode.eventKey.toString().substring(7) : '';
        this.selectIndex.analyzeIndex = value;
        this.formData.analyzeId = tag;
        this.formData.analyzeName = value;
      },
      applyItemChange(value, option) {
        const data = this.applyItems[value];
        this.formData.applyItemCode = data.dictKey;
        this.formData.applyItem = data.dictValue;
        this.getPatientGroup();
      },
      groupItemChange(value, option) {
        const data = this.groupDatas[value];
        this.formData.groupId = data.groupId;
        this.formData.groupName = data.groupName;
      },
      patientItemChange(value, option) {
        const data = this.patientDatas[value];
        this.formData.pipelineId = data.moduleId;
        this.formData.pipelineName = data.name;
      },
      submitClick() {
        this.$refs.ruleForm.validate(valid => {
          if(!valid) { return false; }
          const mes = this.editJobId? '编辑':'添加';
          this.$post('/allconfig/autojob',this.formData,{
              "Content-Type": "application/json"
            }).then(res=>{
            if (res.data.code == 0) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success(mes + "作业成功！");
              this.$emit("close");
            }
          })
        })
      },
      getApplyItem(bol) {
        this.$get('/info/commonDict?dictType=applyItem').then(res=>{
          this.applyItems = res.data.data.rows;
          if(bol) {
            this.applyItems.some((item,index)=>{
              if(item.dictKey == this.editJobRow.applyItemCode) {
                this.selectIndex.applyItemIndex = index;
                this.getPatientGroup(true);
                return true
              }
            });
          }
        })
      },
      getPatientGroup(bol) {
        if(!this.formData.applyItemCode) { 
          // this.$message.error('请先选择检测项目')
          return false; 
        }
        this.$get(`/allconfig/autojob/group/${this.formData.applyItemCode}`).then(res=>{
          this.groupDatas = res.data.data;
          if(bol) {
            if(this.editJobRow.groupId){
              this.groupDatas.push({groupId:this.editJobRow.groupId,groupName:this.editJobRow.groupName});
            }
            this.groupDatas.some((item,index)=>{
              if(item.groupId == this.editJobRow.groupId) {
                this.selectIndex.groupIdIndex = index;
                return true
              }
            });
          }
        })
      },
      getPipelineLst(bol) {
        this.$get("cloudPlatformApi/getCloudPlatformProcessList").then(res => {
          if (res.data.code == 1) {
            this.patientDatas = res.data.data.records;
            if(bol) {
              this.patientDatas.some((item,index)=>{
                if(item.moduleId == this.editJobRow.pipelineId) {
                  this.selectIndex.patientItemIdIndex = index;
                  return true
                }
              });
            }
          }
        });
      },
      cancelSubmit() {
        this.$emit("close");
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>